import React from 'react';
import { Typography, Container, Card, Grid } from '@mui/material';
import { LineGraph } from './LineGraph';

interface IProps {
  obsession: string;
  compulsion: string;
  data: any;
}

export function GraphCard({ obsession, compulsion, data }: IProps) {
  return (
    <Container maxWidth="xl">
      <Card raised style={{ padding: '15px', maxHeight: '500px' }}>
        <Grid
          container
          columnSpacing={2}
          direction="column"
          justifyContent="start"
        >
          <Grid item>
            <Typography variant="h5">Obsession</Typography>
            <Typography variant="h6">{obsession}</Typography>
          </Grid>
          <Grid item>
            <Typography variant="h5">Compulsion</Typography>
            <Typography variant="h6">{compulsion}</Typography>
          </Grid>
          <Grid item>
            <LineGraph data={data} />
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
}
